/**
 * BottomNav — Driver portal bottom tab navigation bar.
 * Extracted from DriverApp.jsx (V2-03.12f).
 * No logic changes — behavior-identical to inline original.
 */

import React from 'react';
import { C, FONT } from '../driver-tokens.js';

var NAV_ITEMS = [
  { id: "home", label: "Home", icon: "\u2302" },
  { id: "stops", label: "Stops", icon: "\u2261" },
  { id: "schedule", label: "Schedule", icon: "\u29D6" },
  { id: "profile", label: "Profile", icon: "\u263A" },
];

function BottomNav({ activeTab, onTabChange }: { activeTab: string; onTabChange: (tab: string) => void }) {
  return React.createElement("div", {
    style: {
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: "rgba(26,35,50,0.95)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
      borderTop: "1px solid rgba(255,255,255,0.06)",
      display: "flex", justifyContent: "space-around", alignItems: "center",
      paddingBottom: "env(safe-area-inset-bottom, 0px)", minHeight: 64,
    }
  },
    NAV_ITEMS.map(function(item) {
      var active = activeTab === item.id;
      return React.createElement("button", {
        key: item.id,
        style: { flex: 1, background: "none", border: "none", cursor: "pointer", padding: "10px 0", textAlign: "center", minHeight: 56 },
        onClick: function() { onTabChange(item.id); }
      },
        React.createElement("div", { style: { fontSize: 20, color: active ? C.gold : C.textMuted, marginBottom: 2 } }, item.icon),
        React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 10, color: active ? C.gold : C.textMuted } }, item.label)
      );
    })
  );
}

export default BottomNav;
